import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import TextInput from '../../../../Shared/TextInput/TextInput';
import { setIsSubmit } from '../../energySaleBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';

const PersonalInfo = (props) => {
  const [personalInfo, setPersonalInfo] = useState({
    firstName: { value: props.firstName, error: '' },
    lastName: { value: props.lastName, error: '' },
  });
  const [currentFocus, setCurrentFocus] = useState('firstName');
  const firstNameRef = useRef();
  const lastNameRef = useRef();

  function handleKeyDown(e, field) {
    if (e.key === 'Enter') {
      switch (field) {
        case 'fistName':
          setCurrentFocus('lastName');
          break;
        case 'lastName':
          setCurrentFocus('email');
          break;
      }
    }
  }

  function handleOnChange(value, field) {
    let isValid = true;
    if (value.trim() == '' || value.length < 2) {
      personalInfo[field] = { value: value, error: 'נא להזין ערך תקין' };
      isValid = false;
    }
    else {
      switch (field) {
        case 'firstName':
        case 'lastName':
          const name = /^[א-תA-Za-z ."״()-/\'/׳]+$/;
          if (!name.test(value)) {
            personalInfo[field] = { value: value, error: 'נא להזין ערך תקין' };
            isValid = false;
          }
          break;
      }
    }
    if (isValid) {
      personalInfo[field] = { value: value, error: '' };
    }
    setPersonalInfo({ ...personalInfo });
  }

  useEffect(() => {
    switch (currentFocus) {
      case 'firstName':
        if (firstNameRef.current) firstNameRef.current.focus();
        break;
      case 'lastName':
        if (lastNameRef.current) lastNameRef.current.focus();
        break;
    }
  }, [currentFocus]);

  useEffect(() => {
    if (props.onSubmit) {
      const validation = isValid();
      const response = setResponse(validation);
      props.onValid(response);
    }
  }, [props.onSubmit]);

  const setResponse = (isValid) => {
    let personalDetails = { firstName: personalInfo.firstName.value, lastName: personalInfo.lastName.value};
    return { personalDetails: personalDetails, isValid: isValid };
  };

  function isValid() {
    let isValid = true;
    if (!personalInfo.firstName.value) {
      isValid = false;
      personalInfo.firstName.error = 'נא להזין שם פרטי';
      setPersonalInfo({ ...personalInfo });
    }
    if (!personalInfo.lastName.value) {
      isValid = false;
      personalInfo.lastName.error = 'נא להזין שם משפחה';
      setPersonalInfo({ ...personalInfo });
    }
    return isValid;
  };

  return (
    <div className='energy-sale-personal-info'>
      <div className='energy-sale-personal-info-wrapper'>
        <div className='form-wrapper'>
          <div>
            <div className= 'rows-wrapper'>
              <div className='row-wrapper'>
                <TextInput
                  value={personalInfo.firstName.value}
                  error={personalInfo.firstName.error}
                  placeholder='שם פרטי'
                  id='firstName'
                  name='firstName'
                  type='text'
                  disabled={false}
                  required='required'
                  minLength='2'
                  onChange={(e) => handleOnChange(e.target.value, 'firstName')}
                  onKeyDown={(e) => handleKeyDown(e, 'firstName')}
                />
              </div>
              <div className='row-wrapper'>
                <TextInput
                  value={personalInfo.lastName.value}
                  error={personalInfo.lastName.error}
                  placeholder='שם משפחה'
                  id='lastName'
                  name='lastName'
                  type='text'
                  disabled={false}
                  required='required'
                  minLength='2'
                  onChange={(e) => handleOnChange(e.target.value, 'lastName')}
                  onKeyDown={(e) => handleKeyDown(e, 'lastName')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );


};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  setIsSubmit,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);
